import { render } from "./Attention.vue?vue&type=template&id=1c280574&scoped=true"
import script from "./Attention.vue?vue&type=script&lang=js"
export * from "./Attention.vue?vue&type=script&lang=js"

import "./Attention.vue?vue&type=style&index=0&id=1c280574&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c280574"]])

export default __exports__